import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { observer } from 'mobx-react'

// Stores
import { UserStoreContext } from '../../stores/UserStore'

/**
 * PublicRoute
 *
 * If a user is authenticated and attempts to access the component, they will be
 * redirected to their home page
 */
const PublicRoute = observer(({ component: Component, ...rest }) => {
  const userStore = useContext(UserStoreContext)
  const { accessToken } = userStore

  return (
    <Route
      {...rest}
      render={props =>
        accessToken ? <Redirect to={{ pathname: '/dashboard' }} /> : <Component {...props} />
      }
    />
  )
})

export default PublicRoute
